import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"

import "./Container.vue?vue&type=style&index=0&id=9ce047f0&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ce047f0"]])

export default __exports__